import React, { useEffect } from "react";
import { UserInterface } from "../../../../store/mine_craft/usersSlice";

import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: UserInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='avatar' label='Avatar' preview={params?.avatar_url} />

      <Form.Item name='name' label="Name">
        <Input />
      </Form.Item>

      <Form.Item name='about_me' label="About me">
        <Input.TextArea rows={10} />
      </Form.Item>

      <Form.Item name='coins' label="Coins">
        <InputNumber min={0} />
      </Form.Item>

      <Form.Item label='Active ADs'>
        <Row>
          <Col span={8}>
            <Form.Item name='banner' valuePropName="checked">
              <Checkbox>Banner</Checkbox>
            </Form.Item>

            <Form.Item name='native_ads' valuePropName="checked">
              <Checkbox>Native Ads</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name='interstitial' valuePropName="checked">
              <Checkbox>Interstitial</Checkbox>
            </Form.Item>

            <Form.Item name='interstitial_long' valuePropName="checked">
              <Checkbox>Interstitial Long</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name='app_open' valuePropName="checked">
              <Checkbox>App Open</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
